import { Avatar, Box, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedChat } from "../../redux/slices/selectedChatSlice";

function AllChats({ userDetail, tabValue, unreadCount, onSelect }) {
  const { selectedChat } = useSelector((state) => state.activeChat);
  const dispatch = useDispatch();
  const adminImage =
    "https://as1.ftcdn.net/v2/jpg/02/59/39/46/1000_F_259394679_GGA8JJAEkukYJL9XXFH2JoC3nMguBPNH.jpg";

  const handleClick = () => {
    const chatUser = { ...userDetail, tabValue };
    localStorage.setItem("selectedUser", JSON.stringify(chatUser));
    dispatch(setSelectedChat(chatUser));
    onSelect && onSelect(userDetail._id);
  };

  return (
    <Stack
      key={userDetail?._id}
      p={"8px 8px"}
      borderRadius={2}
      direction={"row"}
      justifyContent={"space-between"}
      bgcolor={
        userDetail?._id === selectedChat?._id ? "#615EF00F" : "transparent"
      }
      sx={{
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#615EF00F",
        },
      }}
      onClick={handleClick}
    >
      <Stack direction="row" alignItems="center" gap={2}>
        <Box position="relative">
          <Avatar
            sx={{ borderRadius: "25%" }}
            src={tabValue === "business" ? adminImage : userDetail.image}
            alt="user-image"
          />
          {unreadCount > 0 && (
            <Box
              sx={{
                position: "absolute",
                top: -4,
                right: -4,
                backgroundColor: "red",
                color: "white",
                borderRadius: "50%",
                minWidth: "18px",
                height: "18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "0.7rem",
                fontWeight: "bold",
                px: 0.5,
              }}
            >
              {unreadCount > 99 ? "99+" : unreadCount}
            </Box>
          )}
        </Box>

        <Typography
          variant="body1"
          fontSize={"0.875rem"}
          fontWeight={"bold"}
          fontFamily={"Metropolis"}
        >
          {userDetail?.firstname}{" "}
          {userDetail?.lastname ? userDetail?.lastname : ""}
        </Typography>
      </Stack>
    </Stack>
  );
}

export default AllChats;
